export const isValidJwt = (token: string): boolean => {
  try {
    const atb = atob(token.split('.')[1] as string);
    JSON.parse(atb);
    return true;
  } catch (e) {
    return false;
  }
};
